export default "__VITE_ASSET__CerAsbo3__"